import Vue from 'vue'

/**
 * 用户验证服务
 */
export default {
  /**
   * 登录接口（获取token)
   * @param {*} params
   * @param {*} config
   */
  // async sign(params = {}, config = {}) {
  //   let result = await Vue.http.post('/lw-authz-server/oauth/token', params, config);
  //   return result;
  // },
  /**
   * 修改密码接口
   * @param {*} params
   * @param {*} config
   */
  async updatePassword (params = {}, config = {}) {
    const result = await Vue.http.put('/lw-garden-server/account/password', params, config)
    return result
  },

  // 登录页面刷新时判断是否有验证码倒计时
  async stepcode (params = {}, config = {}) {
    const result = await Vue.http.get('/account/validate/code', params, config)
    return result
  },
  // 验证已绑定手机号和现有账户是否统一
  async checkBindCellphone (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/account/bind/phone/check', config)
    return result
  },
  // 发送验证码
  async sendVerficationCode (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/account/verificationCode/send', config)
    return result
  },
  // 获取验证码的倒计时
  async getVerficationCodeCountDown (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/account/verificationCode/countDown', config)
    return result
  },
  // 校验第一步的手机号验证码是否正确
  async checkVerficationCode (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/account/validate/bindPhoneCode', config)
    return result
  },
  /* 修改手机号最后确认接口 */
  async mobilconfirm (params = {}, config = {}) {
    const result = await Vue.http.put('/lw-garden-server/account/modify/cellphone', params, config)
    return result
  },

  // 获取省份列表
  async getProvinceList (params = {}, config = {}) {
    const result = await Vue.http.get('/lw-garden-server/address/province', params, config)
    return result
  },

  // 获取市区列表
  async getCityList (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/address/city', config)
    return result
  },

  // 获取区县列表
  async getDistrictList (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/address/district', config)
    return result
  },

  /* 获取园区类型 */
  async getGardenTypes (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/dictionary/gardenTypes', config)
    return result
  },

  // 查询学段
  async getAllLearningSection (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-system-dictionary-management/grade/learning-section/listAll', config)
    return result
  },

  /* 获取园区列表数据接口 */
  async gerdenList (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/garden', config)
    return result
  },

  // 根据园区Id获取园区详情接口
  async getGardenInfoById (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/garden/' + params.id, config)
    return result
  },

  // 删除园区
  async deleteGarden (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.delete('/lw-garden-server/garden', config)
    return result
  },

  // 新建园区接口
  async addGarden (params = {}) {
    const result = await Vue.http.post('/lw-garden-server/garden', params)
    return result
  },

  // 编辑园区接口
  async updateGarden (params = {}) {
    const result = await Vue.http.put('/lw-garden-server/garden', params)
    return result
  },
  // 编辑园区接口
  async updateUserInfo (params = {}) {
    const result = await Vue.http.put('/lw-garden-server/contact', params)
    return result
  },
  // 获取用户园区集合
  async teacherGardenList (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/garden/simple/group-strategy?isUserControlStrategy=true', config)
    return result
  },
  async studentGardenList (params = {}, config = {}) {
    config.params = params
    const result = await Vue.http.get('/lw-garden-server/garden/student/group-strategy?isUserControlStrategy=false', config)
    return result
  }
}
